import styled from 'styled-components';
import { Typography } from 'antd';
import { PrsonalWrapper } from '@prsonal/website/shared/components';

const { Title, Text } = Typography;

export function ErrorFetchingUser() {
  return (
    <PrsonalWrapper>
      <StyledNoRoleWrapper>
        <Title level={2}>Vi kunne desværre ikke finde din bruger</Title>
        <Text>
          Det kan skyldes at du ikke er en del af projektet, eller at der er sket en fejl i kommunikationen med vores server. 
          <br/>
          Prøv at opdatere siden, og hvis problemet fortsætter, så kontakt os gerne.
        </Text>
      </StyledNoRoleWrapper>
    </PrsonalWrapper>
  );
}

const StyledNoRoleWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
